const keywords = ["黑料免费", "吃瓜", "看料", "在线浏览", "免费阅读"];

const stats = [
  { value: "128", unit: "条", label: "今日新增内容" },
  { value: "3,842", unit: "个", label: "正在讨论的话题" },
  { value: "100%", unit: "", label: "零成本免费阅读" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-primary-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 left-1/4 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl" />

      <div className="relative mx-auto w-full px-4 py-14 md:px-6 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-8">
            <span
              className="inline-flex animate-fade-up items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-medium text-primary-700"
              style={{ animationDelay: "0ms" }}
            >
              <span className="h-1.5 w-1.5 animate-soft-pulse rounded-full bg-accent-500" />
              今日已更新 128 条新料，热度实时刷新中
            </span>

            <h1
              className="animate-fade-up mt-6 font-heading text-3xl font-black leading-[1.25] tracking-tight text-foreground-950 md:text-5xl md:leading-[1.2]"
              style={{ animationDelay: "80ms" }}
            >
              吃瓜看料，
              <span className="text-primary-600">黑料免费</span>
              在线浏览不花一分钱
            </h1>

            <p
              className="animate-fade-up mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base"
              style={{ animationDelay: "160ms" }}
            >
              每天的热门话题、社区讨论和最新看点都被整理在这里，
              <strong className="font-semibold text-foreground-800">无需任何成本</strong>
              即可观看与阅读，随时随地打开就看，满足零成本吃瓜的全部需求。
            </p>

            <div
              className="animate-fade-up mt-7 flex flex-wrap items-center gap-3"
              style={{ animationDelay: "240ms" }}
            >
              <a
                href="#hot"
                className="inline-flex h-12 shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-base" />
                浏览今日热榜
              </a>
              <a
                href="#latest"
                className="inline-flex h-12 shrink-0 items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-list-check-2 w-4 h-4 flex items-center justify-center text-base" />
                查看最新吃瓜
              </a>
            </div>

            <div
              className="animate-fade-up mt-8 flex flex-wrap items-center gap-2"
              style={{ animationDelay: "320ms" }}
            >
              <span className="text-xs font-medium text-foreground-500">大家都在搜</span>
              {keywords.map((word) => (
                <a
                  key={word}
                  href="#topics"
                  className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-foreground-700 transition-colors hover:bg-secondary-100 hover:text-secondary-900"
                >
                  #{word}
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-4">
            <div
              className="animate-fade-up rounded-lg border border-background-200 bg-background-50 p-6"
              style={{ animationDelay: "280ms" }}
            >
              <div className="flex items-center justify-between">
                <h2 className="font-heading text-base font-bold text-foreground-950">今日快览</h2>
                <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                  <i className="ri-refresh-line w-4 h-4 flex items-center justify-center text-sm" />
                  实时
                </span>
              </div>
              <dl className="mt-5 space-y-4">
                {stats.map((item) => (
                  <div
                    key={item.label}
                    className="flex items-baseline justify-between border-b border-background-200/70 pb-4 last:border-0 last:pb-0"
                  >
                    <dt className="text-sm text-foreground-600">{item.label}</dt>
                    <dd className="font-heading text-2xl font-bold text-foreground-950">
                      {item.value}
                      <span className="ml-0.5 text-sm font-medium text-foreground-500">
                        {item.unit}
                      </span>
                    </dd>
                  </div>
                ))}
              </dl>
              <p className="mt-5 flex items-start gap-2 rounded-md bg-primary-50 p-3 text-xs leading-relaxed text-primary-700">
                <i className="ri-information-line mt-0.5 w-4 h-4 flex items-center justify-center text-sm" />
                站点内容全部免费开放，页面按钮仅作浏览演示，不需要注册或付费。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}